/************************************************************************************/
/* WARNING: This file is generated automatically. Don't edit it by hand             */
/************************************************************************************/

import * as api from "./restApi";
import * as t from "./models.generated.types";

function enc(s: any): string { return encodeURIComponent("" + s); }

export interface IModels {
    /** Gets summary for single model */
    modelSummary(req: t.IModelSummaryReq): Promise<t.IModelSummaryRes>;

    /** Runs model for given input parameters */
    evaluateModel(req: t.IEvaluateModelReq): Promise<t.IEvaluateModelRes>;

    /** Runs model for given operation */
    evaluateModelForOperation(req: t.IEvaluateModelForOperationReq): Promise<t.IEvaluateModelForOperationRes>;

    /** Gets details for single model */
    getSingleModel(req: t.IGetSingleModelReq): Promise<t.IGetSingleModelRes>;

    /** Gets input data for single model */
    getSingleModelInputData(req: t.IGetSingleModelInputDataReq): Promise<t.IGetSingleModelInputDataRes>;

    /** Gets models for user's org */
    searchModels(req: t.ISearchModelsReq): Promise<t.ISearchModelsRes>;

    /** Gets report for given model */
    getReport(req: t.IGetReportReq): Promise<t.IGetReportRes>;

    /** Build model */
    buildModel(req: t.IBuildModelReq): Promise<t.IBuildModelRes>;

    /** Get models for org */
    getModels(req: t.IGetModelsReq): Promise<t.IGetModelsRes>;

    /** List pending model versions compared to active and norm */
    getModelsComparison(req: t.IGetModelsComparisonReq): Promise<t.IGetModelsComparisonRes>;

    /** Approve pending model versions */
    approvePendingModels(req: t.IApprovePendingModelsReq): Promise<t.IApprovePendingModelsRes>;

    /** Reject pending model versions */
    rejectPendingModels(req: t.IRejectPendingModelsReq): Promise<t.IRejectPendingModelsRes>;

    /** Updates simulation model and injects tool setup matrix into model */
    updateModelToolSetupMatrix(req: t.IUpdateModelToolSetupMatrixReq): Promise<t.IUpdateModelToolSetupMatrixRes>;

}

export class Models implements IModels {

    client: api.ApiClient;

    constructor(client: api.ApiClient) { this.client = client; }

    /** Gets summary for single model */
    async modelSummary(req: t.IModelSummaryReq): Promise<t.IModelSummaryRes> {
        const reqx: any = req;
        const url = `/api/v1.0/models/summary/${enc(req.line_external_id)}/${enc(req.material_external_id)}/${enc(req.process_num)}`;
        delete reqx.line_external_id;
        delete reqx.material_external_id;
        delete reqx.process_num;
        return (await this.client.get(url, reqx)).data;
    }

    /** Runs model for given input parameters */
    async evaluateModel(req: t.IEvaluateModelReq): Promise<t.IEvaluateModelRes> {
        const reqx: any = req;
        const url = `/api/v1.0/models/evaluate`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Runs model for given operation */
    async evaluateModelForOperation(req: t.IEvaluateModelForOperationReq): Promise<t.IEvaluateModelForOperationRes> {
        const reqx: any = req;
        const url = `/api/v1.0/models/evaluate-for-operation`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Gets details for single model */
    async getSingleModel(req: t.IGetSingleModelReq): Promise<t.IGetSingleModelRes> {
        const reqx: any = req;
        const url = `/api/v1.0/models/details`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Gets input data for single model */
    async getSingleModelInputData(req: t.IGetSingleModelInputDataReq): Promise<t.IGetSingleModelInputDataRes> {
        const reqx: any = req;
        const url = `/api/v1.0/models/input-data`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Gets models for user's org */
    async searchModels(req: t.ISearchModelsReq): Promise<t.ISearchModelsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/models/search`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Gets report for given model */
    async getReport(req: t.IGetReportReq): Promise<t.IGetReportRes> {
        const reqx: any = req;
        const url = `/api/v1.0/getReport`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Build model */
    async buildModel(req: t.IBuildModelReq): Promise<t.IBuildModelRes> {
        const reqx: any = req;
        const url = `/api/v1.0/models/build`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Get models for org */
    async getModels(req: t.IGetModelsReq): Promise<t.IGetModelsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/models`;
        return (await this.client.get(url, reqx)).data;
    }

    /** List pending model versions compared to active and norm */
    async getModelsComparison(req: t.IGetModelsComparisonReq): Promise<t.IGetModelsComparisonRes> {
        const reqx: any = req;
        const url = `/api/v1.0/models/comparison`;
        return (await this.client.get(url, reqx)).data;
    }

    /** Approve pending model versions */
    async approvePendingModels(req: t.IApprovePendingModelsReq): Promise<t.IApprovePendingModelsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/models/approve`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Reject pending model versions */
    async rejectPendingModels(req: t.IRejectPendingModelsReq): Promise<t.IRejectPendingModelsRes> {
        const reqx: any = req;
        const url = `/api/v1.0/models/reject`;
        return (await this.client.post(url, reqx)).data;
    }

    /** Updates simulation model and injects tool setup matrix into model */
    async updateModelToolSetupMatrix(req: t.IUpdateModelToolSetupMatrixReq): Promise<t.IUpdateModelToolSetupMatrixRes> {
        const reqx: any = req;
        const url = `/api/v1.0/models/tool-setup-matrix`;
        return (await this.client.post(url, reqx)).data;
    }

}
